// extracted by mini-css-extract-plugin
export default {"cardForm":"dU3AKOzxYC3LgCdpg0Q_","cardInput":"QLv_iV8PjUciNa9E1k5b","saveCardButton":"IDYkJBTf_Q1BKug82Fk9"};